module.exports = __webpack_public_path__ + "img/Icon_Close_light.bc72b129.svg";